import { createSlice } from '@reduxjs/toolkit'
import { REQUEST_TO_LOGIN, RECEIVE_LOG_IN_RESPONSE, DISPLAY_REJECT_AUTH_DIALOG_BOX, LOGOUT } from '../actions'

const initialState = {
	featureFlags: {},
	environmentVariables: {},
	isLoading: false,
}

const configurationSlice = createSlice({
	name: 'configuration',
	initialState,
	reducers: {
		requestConfiguration: (state) => {
			state.isLoading = true
		},
		receiveConfiguration: (state, action) => {
			state.featureFlags = action.payload.featureFlags
			state.environmentVariables = action.payload.environmentVariables
			state.isLoading = false
		},
		receiveConfigurationError: (state) => {
			state.featureFlags = {}
			state.environmentVariables = {}
			state.isLoading = false
		},
	},
	extraReducers: (builder) => {
		builder
			.addCase(REQUEST_TO_LOGIN, (state) => {
				state.isLoading = true
			})
			.addCase(RECEIVE_LOG_IN_RESPONSE, (state, action) => {
				const configuration = action.payload.body.configuration
				if (configuration) {
					state.featureFlags = configuration.featureFlags || {}
					state.environmentVariables = configuration.environmentVariables || {}
					state.isLoading = false
				}
			})
			.addCase(DISPLAY_REJECT_AUTH_DIALOG_BOX, (state) => {
				state.isLoading = false
			})
			.addCase(LOGOUT, () => initialState)
	},
})

export const {
	requestConfiguration,
	receiveConfiguration,
	receiveConfigurationError,
} = configurationSlice.actions

export default configurationSlice.reducer
